import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchConfig = createAsyncThunk(
  'config/fetchConfig',
  async (selectedRegion) => {
    const response = await fetch('/epyc-platform/config');
    const result = await response.json();

    if (result[selectedRegion]) {
      return result[selectedRegion];
    } else {
      return result['EN'];
    }
  }
);

export default createSlice({
  name: 'config',
  initialState: {config: { links: {} }, loading: false},
  reducers: {},
  extraReducers: {
    [fetchConfig.pending]: (state) => {
      state.config = { links: {}};
      state.loading = true;
    },
    [fetchConfig.fulfilled]: (state, action) => {
      state.config = action.payload;
      state.loading = false;
    },
  },
});
